import { memo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { REVIEW_YOUR_DETAILS as defaultYourDetailsFields } from './review-your-details.config';

import { Section } from '../section';
import { SectionItem } from '../section-item';
import { questionHelpers } from '~/components';
import { isNotEmpty } from '~/utils';

export const YourDetails = memo(
  ({
    clientDetails,
    history,
    yourDetailsFields = defaultYourDetailsFields,
    questions,
    yourDetailsConfig,
    isDisplayQuestions = false,
  }) => {
    const displayQuestions =
      isDisplayQuestions &&
      yourDetailsConfig.isDisplayQuestions &&
      yourDetailsConfig.isDisplayQuestions(questions, clientDetails);
    const allQuestions = displayQuestions
      ? questionHelpers.flatQuestionChildren(questions, clientDetails)
      : [];

    const displayFullName = yourDetailsConfig && yourDetailsConfig.displayFullName;
    const fields = displayFullName
      ? yourDetailsFields.filter(
          ({ fieldName }) => fieldName !== 'firstName' && fieldName !== 'lastName',
        )
      : yourDetailsFields;

    return (
      <Section
        history={history}
        editPath="/edit-your-details"
        analyticsSectionType="details"
        category="Your details"
      >
        {displayFullName && (
          <SectionItem
            key="fullName"
            title="Your name"
            definition={`${clientDetails.title ? clientDetails.title : ''} ${
              clientDetails.firstName
            } ${clientDetails.lastName}`.trim()}
          />
        )}
        {fields.map(({ fieldName, term: title }) => (
          <SectionItem
            key={fieldName}
            title={title}
            definition={isNotEmpty(clientDetails[fieldName]) ? clientDetails[fieldName] : '-'}
          />
        ))}
        {allQuestions.map((question) => {
          const answer = clientDetails[question.reduxFieldConfig.name];
          const definition = question.formatAnswer({ answer, question }) || '-';

          return (
            <SectionItem
              key={question.id}
              title={question.title || question.label}
              definition={definition}
            />
          );
        })}
      </Section>
    );
  },
);

YourDetails.displayName = 'YourDetails';

export const mapStateToProps = (state) => {
  const {
    questions: {
      questions: { RETRIEVED_QUESTIONS },
      restoredAnswers: { yourDetailsSection: restoredClientDetails },
    },
    services: {
      config: { ReviewForm = {}, questionsSectionsConfig = [], ReviewYourDetails = {} },
    },
  } = state;
  const isDisplayQuestions =
    questionsSectionsConfig[0] && questionsSectionsConfig[0].displayQuestionsInYourDetails;
  return {
    clientDetails: restoredClientDetails,
    yourDetailsFields: ReviewForm.yourDetailsFields,
    questions: RETRIEVED_QUESTIONS,
    yourDetailsConfig: ReviewYourDetails,
    isDisplayQuestions,
  };
};

export const ConnectedYourDetailsWithRouter = withRouter(connect(mapStateToProps)(YourDetails));

YourDetails.propTypes = {
  clientDetails: PropTypes.shape().isRequired,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  yourDetailsFields: PropTypes.arrayOf(PropTypes.shape({})),
  yourDetailsConfig: PropTypes.shape({}).isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isDisplayQuestions: PropTypes.bool,
};
